import { useState } from 'react';

export const useToggle = (initialValue: boolean = false) => {
  const [state, setState] = useState<boolean>(initialValue);

  const toggle = () => setState(prev => !prev);

  const close = () => {
    setState(false);
  };
  const open = () => {
    setState(true);
  };

  return { state, toggle, setState, close, open };
};
